
/**
 * Returns the value, or the min or max if the value is outside those bounds (which are inclusive).
 */
export function clamp(value: number, min: number, max: number): number {
  if (max < min) {
    return NaN;
  }
  return Math.min(Math.max(value, min), max);
}

/**
 * Returns the value, or the min or max if the value is outside those bounds (which are inclusive).
 * If the value falls outside the bounds, it wraps to the other end.
 */
export function wrap(value: number, min: number, max: number): number {
  if (max < min || isNaN(value) || isNaN(min) || isNaN(max)) {
    return NaN;
  }

  if (value > max) {
    return min;
  } else if (value < min) {
    return max;
  } else {
    return value;
  }
}
